import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import EventBusyIcon from '@mui/icons-material/EventBusy'

const ShiftNotAssigned = ({ onRetry }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px',
                textAlign: 'center',
                padding: '24px',
                marginBottom: 'auto',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    bgcolor: '#FFEDED',
                    borderRadius: '50%',
                    width: 96,
                    height: 96,
                }}
            >
                <EventBusyIcon sx={{ fontSize: 48, color: 'error.main' }} />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Typography variant="h4" sx={{ fontWeight: 600, color: 'dark-text.main' }}>
                    Shift not assigned
                </Typography>
                <Typography sx={{ color: 'light-gray-text.main' }}>
                    We cannot proceed with clock-in because your work shift has not been set up yet.
                </Typography>
            </Box>

            <Box sx={{ textAlign: 'left', width: '100%' }}>
                <ul style={{ margin: 0, paddingLeft: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <li>
                        <Typography sx={{ color: 'light-gray-text.main', fontSize: '14px' }}>
                            Your manager needs to assign your working hours before you can clock in
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={{ color: 'light-gray-text.main', fontSize: '14px' }}>
                            Please contact your HR or supervisor for assistance
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={{ color: 'light-gray-text.main', fontSize: '14px' }}>
                            Once your shift is assigned, you can try again
                        </Typography>
                    </li>
                </ul>
            </Box>

            <AdxButton fullWidth onClick={onRetry} sx={{ mt: 1 }}>
                Return to Dashboard
            </AdxButton>
        </Box>
    )
}

export default ShiftNotAssigned
